import React from 'react';
import { FloatingChatButton } from './FloatingChatButton';
import { FloatingChatInterface } from './FloatingChatInterface';
import { useFloatingChat } from '../../contexts/FloatingChatContext';

interface FloatingChatWrapperProps {
  userRole: string | null;
}

export const FloatingChatWrapper: React.FC<FloatingChatWrapperProps> = ({ userRole }) => {
  const { isOpen, preparationId, closeChat } = useFloatingChat();

  // Only hide for recruiters
  // Show for interviewers and during loading (null) to avoid delayed rendering
  if (userRole === 'recruiter') return null;

  return (
    <>
      <FloatingChatButton />
      <FloatingChatInterface
        isOpen={isOpen}
        onClose={closeChat}
        preparationId={preparationId}
      />
    </>
  );
};
